import {ConfigText} from 'components/common/ConfigText'
import {Step} from '../Step/Step'
import {MaximizedCalendar} from './MaximizedCalendar'
import {MinimizedCalendar} from './MinimizedCalendar'

export const Calendar = () => {
  return (
    <Step
      title="Date"
      caption={<ConfigText configKey="calendarCaption" defaultText="When's your tour date?" />}
      thisStepCode="date"
      minimizedComponent={MinimizedCalendar}
      maximizedComponent={MaximizedCalendar}
    />
  )
}
